export default "__VITE_ASSET__r6F6bkaX__"